<template>
  <div class="fillcontain">
    <!-- <div>
      <commontop @topclick="topclick"></commontop>
    </div> -->
    <div class="center">
      <div class="lefts" style="background-color: #FFFFFF;box-shadow: 0px 1px 4px 0px  rgba(0, 0, 0, 0.1);">
        <Inboundlisttow :titleList="titleList"></Inboundlisttow>
      </div>

      <div class="contextBox">
          <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
// import commontop from '../../components/common-top.vue'
import Inboundlisttow from '../../components/Inboundlist-tow.vue'
import Inboundlistcenter from '../Inboundlist/components/Inboundlist-center.vue'
export default {
  components: {
    // commontop,
    Inboundlisttow,
    Inboundlistcenter
  },
  data() {
    return {
      titleList: [
        // { title: "发票上报管理", router: "invoicesubmissionmanagement" },
      ],
      
    }
  },
  created() {

  },
  mounted() {
    this.userInfoMun()
  },
  computed: {
    defaultActive: function () {
      let index = this.$route.path.replace('/', '')
      // //console.log('路由地址为=' + index)
      return index;
    }
  },
  methods: {
     userInfoMun() {
      let data = JSON.parse(localStorage.getItem("MenusData"))
      data.Menus.map((item, index) => {
        if (item.NodeID == 74) {
          this.titleList = item.Nodes
        }
      })
    },
  },

}
</script>

<style lang= "less" scoped>
@import "../../style/mixin.less";

.center {
  /* 定宽 */
  .zwidth(100%);
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-top: 20px;
}
</style>